
export const Routes = {
  // pages
  // Presentation: { path: "/" },
  DashboardOverview: { path: "/" },///dashboard/overview
  DeliveryTransactions: { path: "/deliveries" },
  PaceUsers: { path: "/paceUsers" },
  Settings: { path: "/settings" },
  Signin: { path: "/modules/sign-in" },
  Signup: { path: "/modules/sign-up" },
  ForgotPassword: { path: "/modules/forgot-password" },
  ResetPassword: { path: "/modules/reset-password" },
  Lock: { path: "/modules/lock" },
  NotFound: { path: "/modules/404" },
  ServerError: { path: "/modules/500" },

  Upgrade: { path: "/upgrade" },
  BootstrapTables: { path: "/tables/bootstrap-tables" },
  Billing: { path: "/modules/billing" },
  Invoice: { path: "/modules/invoice" },

  // docs
  DocsOverview: { path: "/documentation/overview" },
  DocsDownload: { path: "/documentation/download" },
  DocsQuickStart: { path: "/documentation/quick-start" },
  DocsLicense: { path: "/documentation/license" },
  DocsFolderStructure: { path: "/documentation/folder-structure" },
  DocsBuild: { path: "/documentation/build-tools" },
  DocsChangelog: { path: "/documentation/changelog" },

  // components
  Accordions: { path: "/components/accordions" },
  Alerts: { path: "/components/alerts" },
  Badges: { path: "/components/badges" },
  Widgets: { path: "/widgets" },
  Breadcrumbs: { path: "/components/breadcrumbs" },
  Buttons: { path: "/components/buttons" },
  Forms: { path: "/components/forms" },
  Modals: { path: "/components/modals" },
  Navs: { path: "/components/navs" },
  Navbars: { path: "/components/navbars" },
  Pagination: { path: "/components/pagination" },
  Popovers: { path: "/components/popovers" },
  Progress: { path: "/components/progress" },
  Tables: { path: "/components/tables" },
  Tabs: { path: "/components/tabs" },
  Tooltips: { path: "/components/tooltips" },
  Toasts: { path: "/components/toasts" },
  WidgetsComponent: { path: "/components/widgets" }
};